import { Dictionary, EntityState } from '@reduxjs/toolkit';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { Prefab } from '../Prefab';
import { editInput } from './editInput';
import { merge } from './merge';

export const createUserInputsPatch = (
    forUserInputs: EntityState<GiftJson.Input<any>>,
    fromPrefab: Prefab
) => {

    const patch: Dictionary<GiftJson.Input<any>> = {};

    for (const id of fromPrefab.variables.ids as string[]) {

        const variable = fromPrefab.variables.entities[id]!;
        const prefabInput = fromPrefab.inputs.entities[id]!;
        const userInput = forUserInputs.entities[id];

        patch[id] = userInput
            ? merge(userInput, prefabInput, variable, 'prefabIntoInput')
            : prefabInput;

        if (isEmptyTextInput(userInput, variable.pluginId)) {
            patch[id] = clearText(patch[id]!);
        }
    }

    return patch;
};

const isEmptyTextInput = (input: GiftJson.Input<any> | undefined, pluginId: string) => {
    return pluginId === 'text' && (!input || input.value.content === '');
};

const clearText = (input: GiftJson.Input<any>) => {
    return typeof input.value.content === 'string'
        ? editInput(input, { content: '' })
        : input;
};